module.exports = __webpack_public_path__ + "img/coors-light-landing-gal-11.650b3b46.jpg";